export const SITE_NAME = 'RealEstats';
export const DEFAULT_SITE_ORIGIN = 'https://realestats.org';

/**
 * Where corrections and right-of-reply requests go. Owner action: set this
 * before agent pages become indexable (SEO_INDEX_AGENTS=true). While null the
 * pages explain that a contact is being set up.
 */
export const CORRECTIONS_CONTACT = null; // e.g. { email: 'corrections@example.org' }

/** Current minimum samples, mirrored in copy on the methodology page. */
export const THRESHOLDS = {
  suburbMinGuideMatched12m: 10,
  agentMinGuideMatched24m: 8,
  lowSampleMonth: 5,
};

export const PAGE_SCHEMAS = {
  suburb: 'realestats.page.suburb/v1',
  agent: 'realestats.page.agent/v1',
  'suburb-index': 'realestats.page.suburb-index/v1',
  'not-found': 'realestats.page.not-found/v1',
};

export function pagePath(type, slug) {
  if (type === 'suburb') return `/suburbs/${slug}`;
  if (type === 'agent') return `/agents/${slug}`;
  if (type === 'suburb-index') return '/suburbs';
  if (type === 'methodology') return '/methodology';
  return '/suburbs/not-found';
}

/** Static JSON location for client-side navigation between pages. */
export function pageDataPath(type, slug) {
  return `/data/pages/${type}/${slug}.json`;
}

export function ogImagePath(type, slug) {
  return `/og/${type}/${slug}.png`;
}
